import { Form, Input, Modal, message } from "antd";
import { useCreatePositionMutation, useCreateZoneMetadataMutation } from "pacts/app-webcore/hasura-webcore.graphql";
import React from "react";

interface CreateZoneModalProps {
  locationId: string;
  visible: boolean;
  onClose: () => void;
  onCompleted?: () => void;
}

const CreateZoneModal: React.FC<CreateZoneModalProps> = ({ locationId, visible, onClose, onCompleted }) => {
  const [form] = Form.useForm();
  const [createPosition, { loading: creatingPosition }] = useCreatePositionMutation();
  const [createZoneMetadata, { loading: creatingZoneMetadata }] = useCreateZoneMetadataMutation();

  const handleSubmit = async (values: { zoneName: string }) => {
    try {
      // 1. Create the position (zone)
      const { data } = await createPosition({
        variables: {
          input: {
            locationId,
            positionName: values.zoneName,
            positionType: "zone",
            positionFunction: "group",
            parentPositionId: locationId,
          },
        },
      });
      const positionId = data?.createPosition?.positionId;
      if (!positionId) throw new Error("Failed to create zone position");
      // 2. Create the zone metadata
      await createZoneMetadata({
        variables: {
          zoneMetadata: {
            positionId,
            zoneName: values.zoneName,
          },
        },
      });
      message.success("Zone created!");
      form.resetFields();
      onCompleted?.();
      onClose();
    } catch (error: any) {
      message.error(error.message || "Failed to create zone");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Create Zone"
      visible={visible}
      onCancel={handleCancel}
      onOk={form.submit}
      okText="Create"
      confirmLoading={creatingPosition || creatingZoneMetadata}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="zoneName" label="Zone Name" rules={[{ required: true, message: "Zone name is required" }]}>
          <Input placeholder="Enter zone name" autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateZoneModal;
